import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-cards",
  templateUrl: "./cards.component.html",
  styleUrls: ["./cards.component.sass"],
})
export class CardsComponent implements OnInit {
  @Input() icon: string = 'person';
  @Input() iconType: 'feather' | 'material' | 'fa' = 'feather';
  @Input() iconBgColor: string = '#B32317';
  @Input() label: string = 'Subscribers';
  @Input() value: string | number = '40000';
  @Input() subtitle: string = 'Active Subscriber';
  @Input() showArrow: boolean = true;

  constructor() {}

  ngOnInit(): void {}
}
